<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차서비스</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차서비스</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">정기권</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권">정기권</router-link></li>
            <li><router-link to="/webdiscountcharge" title="웹 선불권">웹 선불권</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">정기권 안내</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권 안내">정기권 안내</router-link></li>
            <li><router-link to="/periodapplication" title="정기권 신청">정기권 신청</router-link></li>
            <!-- <li><router-link to="/periodlookup" title="정기권 조회/결제">정기권 조회/결제</router-link></li> -->
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">정기권 안내</h3>
        <article>
          <p class="subTitle">정기권 온라인 신청 절차</p>
          <!--periodStep-->
          <div class="periodStep web">
            <ul>
              <li class="step01">인터넷 정기권<br />발매 공고</li>
              <li class="step02">로그인</li>
              <li class="step03">정기권 신청</li>
              <li class="step04">증명서 제출<br />(대상자에 한함)</li>
              <li class="step05">대상자 확인</li>
              <li class="step06">결제</li>
            </ul>
          </div>
          <div class="periodStep mobile">
            <ul>
              <li class="step01">인터넷 정기권<br />발매 공고</li>
              <li class="step02">로그인</li>
              <li class="step03">정기권 신청</li>
              <li class="step04">결제</li>
              <li class="step05">대상자 확인</li>
              <li class="step06">증명서 제출<br />(대상자에 한함)</li>
            </ul>
          </div>
          <!--//periodStep-->
          <div class="infoBox">
            <ul class="bullet arrowType">
              <li>
                정기권은 선착순을 통해 판매가 진행되며, <strong class="point">3개월(분기별)</strong> 단위 신청 및 이용이 가능합니다.
                <span class="subNote">※ 월중 신청 시 일할계산</span>
              </li>
              <li>본인 명의의 차량 한 대만 신청이 가능하며, 월정기권 운영 주차장에 한하여 신청이 가능합니다.</li>
              <li class="caution">
                월정기권 별도 지정 구역 미운영하며, 주차장 만차 시 대기 발생 및 주차 불가할 수 있습니다.
              </li>
            </ul>
          </div>
        </article>
        <article>
          <p class="subTitle">이용요금 <span class="note">(1개월 기준 요금)</span></p>
          <div class="table blue-table">
            <table>
              <caption>
                노상주차장 정기권 요금 안내 테이블
              </caption>
              <colgroup>
                <col style="width: 20%" />
                <col style="width: 20%" />
                <col style="width: 20%" />
                <col style="width: 20%" />
                <col style="width: 20%" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">대상주차장</th>
                  <th scope="col">급지</th>
                  <th scope="col">주간<br /><span>(08:00 ~ 20:00)</span></th>
                  <th scope="col">야간<br /><span>(18:30 ~ 익일08:00)</span></th>
                  <th scope="col">주야간(전일)<br /><span>(08:00 ~ 익일8:00)</span></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">공설운동장, 북샛말, 서희청소년문화센터, 사동리</th>
                  <td>2급지</td>
                  <td><span class="f15">50,000원</span></td>
                  <td><span class="f15">30,000원</span></td>
                  <td><span class="f15">60,000원</span></td>
                </tr>
                <tr>
                  <th scope="row">택시쉼터</th>
                  <td>3급지</td>
                  <td><span class="f15">30,000원</span></td>
                  <td><span class="f15">20,000원</span></td>
                  <td><span class="f15">40,000원</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article>
          <p class="subTitle">월정기권 운영 현황</p>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table month-table">
              <table>
                <caption>
                  월정기권 운영 현황
                </caption>
                <colgroup>
                  <col style="width: 20%" />
                  <col style="width: 25%" />
                  <col style="width: 15%" />
                  <col style="width: 15%" />
                </colgroup>

                <thead>
                  <tr>
                    <th scope="col">주차장</th>
                    <th scope="col">주소</th>
                    <th scope="col">주차면수</th>
                    <th scope="col">비고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">북샛말 주차장</th>
                    <td>경기 이천시 이섭대천로 1299</td>
                    <td>176면</td>
                    <td rowspan="5"><span></span></td>
                  </tr>
                  <tr>
                    <th scope="row">서희청소년문화센터 주차장</th>
                    <td>경기 이천시 영창로 260</td>
                    <td>195면</td>
                  </tr>
                  <tr>
                    <th scope="row">택시쉼터 주차장</th>
                    <td>경기 이천시 창전동 417</td>
                    <td>230면</td>
                  </tr>
                  <tr>
                    <th scope="row">공설운동장 주차장</th>
                    <td>경기 이천시 서희로 11</td>
                    <td>464면</td>
                  </tr>
                  <tr>
                    <th scope="row">사동리 주차장</th>
                    <td>경기 이천시 대산로208번길 (대월면,사동리,휴먼빌 에듀파크시티)</td>
                    <td>41면</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="info">운영시간 : 24시간 연중휴무</p>
          </div>
        </article>
        <article>
          <p class="subTitle">월정기권 신청 및 운영사항</p>
          <div class="infoArticle">
            <p class="tit">1. 신청 및 이용기간</p>
            <ul class="bullet dotType">
              <li><strong class="point">3개월(분기별)</strong> 단위로 신청 및 이용이 가능하며, 월중 신청 시 일할계산됩니다.</li>
              <li>
                본인 명의의 차량 한 대만 신청이 가능하며, 차량등록증을 필히 제출해 주셔야 합니다. 단, 본인 명의 외 차량을
                등록하는 경우 가족관계증명서, 렌트·리스 계약서 등의 증빙서류의 추가 제출이 필요할 수 있습니다.
              </li>
              <li>월정기권 운영 주차장에 한하여 신청이 가능합니다.</li>
              <li>월정기권 운영 면수 초과 시 대기 접수 후 순차적으로 등록됩니다. (해당자에게 개별연락, 연락 불가 시 차후 순위로 넘어감)</li>
            </ul>
          </div>
          <div class="infoArticle">
            <p class="tit">2. 월정기권 결제 방법 <span class="note">(1개월 기준 요금)</span></p>
            <ul class="bullet dotType">
              <li>월정기권 이용요금은 신청 접수 시 선불로 결제해야 합니다.</li>
              <li>
                월정기권 <strong>만료일</strong> 내 미결제 시 자동 해지되며, 해지 시 원상복구가 불가하고, 신규 신청 후 대기로
                넘어가오니 숙지바랍니다.
              </li>
              <li>
                정기권 취소·환불은 가능하며, <strong class="point">환불신청일 익일부터</strong> 잔여기간을 일할계산하여
                환급합니다. (사용개시전 100% 환불)
              </li>
              <li class="caution">월정기권 미적용시간 주차 시 시간주차료 발생합니다.</li>
            </ul>
          </div>
          <div class="infoArticle">
            <p class="tit">3. 월정기권 요금 감면</p>
            <ul class="bullet dotType">
              <li>감면대상자의 경우, 정기권 등록 및 차량변경 시 적합한 증빙서류를 제출해야 감면혜택 적용이 가능합니다. (예: 차량등록증, 다자녀카드 등)</li>
              <li>중복할인이 불가하며, 둘 이상 감면대상에 해당되는 경우 감면율이 높은 하나만 적용됩니다.</li>
              <li>사용이 종료된 정기권에 대해서는 감면혜택 소급적용이 불가합니다.</li>
            </ul>
          </div>
          <div class="infoArticle">
            <p class="tit">4. 차량 변경</p>
            <ul class="bullet dotType">
              <li>정기등록 차량 변경 시 사전에 변경서류를 제출하고 변경 등록 조치 후 이용이 가능합니다.</li>
              <li>
                본인 명의 차량만 변경 가능하며, 해당하는 필요서류를 제출하실 경우, 정기등록 차량번호 변경이 가능합니다.
                (양도불가)
              </li>
            </ul>
          </div>
        </article>
        <article>
          <p class="subTitle">월정기권 이용 시 유의사항</p>
          <ul class="bullet dotType">
            <li>
              1톤 초과차량, 캠핑카, 트레일러, 주차장별 폭·높이 제한 차량 등 주차장 환경(구조)에 적합하지 않은 차량은 정기권
              신청 및 이용이 불가합니다.
              <div class="scroll-table">
                <i class="v-scroll"></i>
                <div class="table month-table">
                  <table>
                    <caption>
                      주차장별 제한높이
                    </caption>
                    <colgroup>
                      <col style="width: 50%" />
                      <col style="width: 50%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th scope="col">주차장명</th>
                        <th scope="col">제한높이</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">서희청소년문화센터</th>
                        <td>2.0M</td>
                      </tr>
                      <tr>
                        <th scope="row">택시쉼터, 사동리</th>
                        <td>2.1M</td>
                      </tr>
                      <tr>
                        <th scope="row">북샛말, 공설</th>
                        <td>2.3M</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </li>
            <li>
              공영주차장은 월정기권 및 일반차량 통합 운영 시설로
              <strong class="point">월정기권 별도 지정 구역 미운영하며, 주차장 만차 시 대기 발생 및 주차 불가할 수 있습니다.</strong>
            </li>
            <li>월정기권을 신청한 공영주차장 외 <strong>타</strong> 공영주차장에 주차할 경우 주차요금이 발생합니다.</li>
            <li>주차장 차고지 방지를 위해 14일 이상 장기주차 시, 이동조치 또는 견인될 수 있으며 추후 정기권 신청에 제한이 있을 수 있습니다.</li>
            <li>
              천재지변(폭설 등) 또는 시설공사 등으로 이용이 일부 제한되거나 무료로 운영되는 기간이 있을 수 있으며,
              해당기간에 대해서는 별도의 환급 및 할인이 불가합니다.
            </li>
            <li class="caution">
              정기권 연장 안내 문자는 고객 편의를 위한 서비스며, 문자 수신불가 등의 사유로 인한 월정기권 자동 해지에 대한
              책임은 신청자 본인에게 있습니다.
            </li>
            <li>전화번호 변경 시 월정기권 안내 문자를 받지 못할 수 있으므로 변경사항 발생 시 즉시 변경해 주시기 바랍니다.</li>
            <li>정기권 감면 대상자 중 부정사용 2회 적발 시 주차요금 감면금액 전액 환수 및 정기권 배정 제한이 있을 수 있습니다.</li>
            <li class="caution">유의사항 미확인 및 오기재로 인해 발생하는 불이익은 정기권 신청자 본인에게 있습니다.</li>
          </ul>
        </article>
        <article class="btnArea">
          <button type="button" class="btn blue" @click="$router.push('/periodapplication')">정기권 신청</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {},
};
</script>
